<template>
  <div id="userSetting" v-loading="isLoading">
    <!-- <header-top :headerText="headerText"></header-top> -->
    <main class="main">
      <el-form label-position="left">
        <div class="form-info">
          <div class="configuration-rules">
            <div class="tit">人事配置规则</div>
            <el-form-item
              v-for="(item, index) in userSetting"
              :key="index"
              class="auto-height"
            >
              <div class="rules-name">{{ item.displayName }}</div>
              <el-checkbox
                v-model="item.value"
                v-if="
                  item.value === true ||
                  item.value === false ||
                  item.value === 'true' ||
                  item.value === 'false'
                "
                >{{ item.displayName }}</el-checkbox
              >
              <el-input
                v-else
                v-model="item.value"
                clearable
                :min="0"
                :placeholder="`请输入${item.displayName}`"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-info">
          <div class="userSetting-settings">
            <div class="tit">公司配置规则</div>
            <el-form-item
              v-for="(item, index) in ouSetting"
              :key="index"
              class="auto-height"
            >
              <div class="rules-name">{{ item.displayName }}</div>

              <el-checkbox
                v-model="item.value"
                v-if="
                  item.value === true ||
                  item.value === false ||
                  item.value === 'true' ||
                  item.value === 'false'
                "
                >{{ item.displayName }}</el-checkbox
              >
              <el-input
                v-else
                v-model="item.value"
                clearable
                :min="0"
                :placeholder="`请输入${item.displayName}`"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form-info">
          <div class="group-btn">
            <el-button type="primary" @click="submit" :loading="submitLoading"
              >保存</el-button
            >
            <el-button @click="$router.go(-1)">取消</el-button>
          </div>
        </div>
      </el-form>
    </main>
  </div>
</template>

<script>
// import headerTop from "@/components/HeaderTop";

import {
  getUserSettings,
  updateUserSettings,
  getOuSettings,
  updateOuSettings,
} from "@/http/api/system";
import { deepCopy } from "@/utils/deepCopy";
export default {
  props: {
    isEdit: { type: Boolean },
  },
  components: {
    // headerTop,
  },
  data() {
    return {
      headerText: "账户配置",
      isLoading:true,
      requireData: [],
      ouSetting: [],
      userSetting: [],
      ouSettings: [],
      permissions: this.$store.getters.permissions,
      submitLoading: false,
      isSmsCloaseLoading: false,
      isSmsLoadingSubmit: false,
      filterSettings: [],
    };
  },
  mounted() {
    this.getSettingsDataInfo();
  },
  methods: {
    submit() {
      if (this.permissions["System.UserSettings.Update"]) {
        this.submitLoading = true;
        this.ouSetting.map((item) => {
          this.requireData.push({
            name: item.name,
            value: item.value,
            isVisibleToClients: item.isVisibleToClients,
            isCollection: item.isCollection,
          });
        });
        this.userSetting.map((item) => {
          this.requireData.push({
            name: item.name,
            value: item.value,
            isVisibleToClients: item.isVisibleToClients,
            isCollection: item.isCollection,
          });
        });
        let userSettings = {
          settings: this.userSetting,
        };
        let ouSettings = {
          settings: this.ouSetting,
        };
        var query = this.$store.getters.generateUpdateSettingsParams;
        updateUserSettings(query,userSettings).then((res) => {
          updateOuSettings(query,ouSettings).then((res) => {
            this.submitLoading = false;
            this.getSettingsDataInfo();
          });
        });
      } else {
        this.$message.warning({
          message: `您暂无账户配置权限`,
          showClose: true,
        });
      }
    },

    getSettingsDataInfo() {
      this.isLoading = true
      this.userSetting.map((item) => {
        this.requireData.push({
          name: item.name,
          value: item.value,
          isVisibleToClients: item.isVisibleToClients,
          isCollection: item.isCollection,
        });
      });
      let userSettings = {
        settings: this.userSetting,
      };
      this.filterSettings = []
      getUserSettings().then((res) => {
        res.result.map((item) => {
          if (!item.isCollection) {
            this.filterSettings.push(item);
          }
        });

        this.userSetting = deepCopy(this.filterSettings);
      });

      this.getOuSettings();
    },
    getOuSettings() {
      this.ouSettings= []
      getOuSettings().then((res) => {
        res.result.map((item) => {
          if (!item.isCollection) {
            this.ouSettings.push(item);
          }
        });
        //console.log(res.result, 9999, this.ouSettings);
        setTimeout(()=>{
          this.isLoading = false
        },300)
        
        this.ouSetting = deepCopy(this.ouSettings);
      });
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";

#userSetting {
  .main {
    min-width: 900px;
    min-height: calc(100vh - 150px);
    text-align: left;

    .form-info {
      padding: 20px;
      background: #fff;
    }
    .configuration-rules,
    .userSetting-settings,
    .sms-settings {
      margin-bottom: 20px;
      padding-bottom: 10px;
      border-radius: $--border-radius-base;
      .tit {
        margin-bottom: 25px;
        font-size: 14px;
        font-weight: bold;
        color: #000;
      }
      .custom-height {
        margin-bottom: 20px;
      }
      .tips {
        margin-top: 7px;
        height: 14px;
        line-height: 14px;
        font-size: 12px;
        color: #878787;
      }

      .el-form-item {
        margin-bottom: 25px;
      }
      ::v-deep .el-form-item__content {
        .el-checkbox {
          margin-right: 0;
          .el-checkbox__label {
            padding-left: 6px;
            color: #2c3e50;
          }
        }
        .el-radio-button__inner {
          height: 30px;
          line-height: 10px;
        }
      }
      .el-input {
        width: 332px;
      }
      .prefix {
        @include flex(row, center);
        img {
          margin: 0 12px;
          width: 10px;
          height: 10px;
        }
        .el-input {
          margin-bottom: 10px;
          width: 124px;
        }
      }
      .template {
        margin: 5px 0 4px;
        height: 14px;
        line-height: 14px;
        font-size: 12px;
        color: #888;
      }
      .prefix-tips {
        height: 14px;
        line-height: 14px;
        font-size: 12px;
        color: #ff9d00;
      }
    }
  }
}
</style>
